import { EmptyImpl, PRESENTED_IMAGE_DEFAULT } from './components/EmptyImpl';
export var Empty = Object.assign(EmptyImpl, {
  PRESENTED_IMAGE_DEFAULT: PRESENTED_IMAGE_DEFAULT
});